import http from "../../http-common";
/* eslint-disable */
class PengaduanService {
  pengaduanList(page, itemPerPage, keyword) {
    return http.get(
      "/pengaduan/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      }
    );
  }

  create(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("nama", data.nama);
    bodyFormData.append("no_telepon", data.no_telepon);
    bodyFormData.append("no_ktp", data.no_ktp);
    bodyFormData.append("pengaduan", data.pengaduan);

    if (data.selectedStatus && data.selectedStatus != undefined) {
      bodyFormData.append("status", data.selectedStatus.text);
    }

    return http.post("/pengaduan", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  update(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    bodyFormData.append("nama", data.nama);
    bodyFormData.append("no_telepon", data.no_telepon);
    bodyFormData.append("no_ktp", data.no_ktp);
    bodyFormData.append("pengaduan", data.pengaduan);

    if (data.selectedStatus && data.selectedStatus != undefined) {
      bodyFormData.append("status", data.selectedStatus.text);
    }

    return http.put(`/pengaduan/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  delete(id) {
    return http.delete(`/pengaduan/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new PengaduanService();
